import {
  localActiveAutomationsSeed,
  localSuggestedAutomationsSeed,
  localAutomationTimeFilterOptions,
  localAutomationUsageByPeriodSeed,
  localAutomationUsageByUserSeed,
} from '@/modules/automations/mocks/automations.mock';
import {
  buildAutomationUpdateRequest,
  buildCustomAutomationRequest,
} from '@/modules/automations/utils';

// Local/mock compat module only.
// This service does not read from or persist to any backend source of truth.
// All returned datasets and request actions are local demo seeds or in-memory results.

function buildMutationResult({ ok, data = null, error = null, message = '' }) {
  return {
    ok,
    data,
    error,
    message,
  };
}

export function getLocalAutomationsCatalog() {
  return [...localActiveAutomationsSeed];
}

export function getLocalSuggestedAutomationsCatalog() {
  return [...localSuggestedAutomationsSeed];
}

export function getLocalAutomationTimeFilters() {
  return [...localAutomationTimeFilterOptions];
}

export function getLocalAutomationUsageByPeriodSeed() {
  return { ...localAutomationUsageByPeriodSeed };
}

export function getLocalAutomationUsageByUserSeed() {
  return { ...localAutomationUsageByUserSeed };
}

export function toggleLocalAutomationRenewalStatus(renewalStatus, automationId) {
  if (!automationId) {
    return buildMutationResult({
      ok: false,
      error: 'AUTOMATION_NOT_FOUND',
      message: 'Automazione non trovata.',
    });
  }

  const isRenewalActive = Boolean(renewalStatus[automationId]);
  const nextRenewalStatus = {
    ...renewalStatus,
    [automationId]: !isRenewalActive,
  };

  return buildMutationResult({
    ok: true,
    data: {
      renewalStatus: nextRenewalStatus,
      automationId,
      renewalActive: nextRenewalStatus[automationId],
    },
    message: nextRenewalStatus[automationId]
      ? 'Rinnovo locale riattivato nella demo.'
      : 'Rinnovo locale disattivato nella demo.',
    });
}

export function submitLocalAutomationUpdateRequest(automation, text) {
  const requestText = text?.trim();

  if (!automation?.id) {
    return buildMutationResult({
      ok: false,
      error: 'AUTOMATION_NOT_FOUND',
      message: 'Automazione non trovata.',
    });
  }

  if (!requestText) {
    return buildMutationResult({
      ok: false,
      error: 'EMPTY_UPDATE_REQUEST',
      message: 'Inserisci una richiesta di modifica.',
    });
  }

  const request = buildAutomationUpdateRequest(automation, requestText);

  return buildMutationResult({
    ok: true,
    data: {
      request,
    },
    message: 'Richiesta locale registrata nella demo.',
  });
}

export function submitLocalSuggestedAutomationRequest(payload) {
  return { ...payload };
}

export function submitLocalCustomAutomationRequest(request) {
  const description = request?.descrizione?.trim();

  if (!description) {
    return buildMutationResult({
      ok: false,
      error: 'EMPTY_CUSTOM_AUTOMATION_REQUEST',
      message: "Inserisci la descrizione dell'automazione richiesta.",
    });
  }

  const customRequest = buildCustomAutomationRequest(request);

  return buildMutationResult({
    ok: true,
    data: {
      request: customRequest,
    },
    message: 'Richiesta personalizzata registrata localmente nella demo.',
  });
}
